export function fillTemplate(pattern: string, values: Record<string, string | number | undefined>): string {
  return pattern.replace(/\{(\w+)\}/g, (_match, key: string) => String(values[key] ?? ""));
}
